var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumber19SvgrepoCom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "#ECECEC",
  viewBox: "-3.2 -3.2 38.40 38.40",
  stroke: "#ECECEC",
  strokeWidth: 0.00032,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0,
  transform: "translate(3.1999999999999993,3.1999999999999993), scale(0.8)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -3.2,
  y: -3.2,
  width: 38.4,
  height: 38.4,
  rx: 19.2,
  fill: "#7F7F7F",
  strokeWidth: 0
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.738 11.478c-0.233-0.19-0.5-0.286-0.801-0.286s-0.569 0.096-0.805 0.286c-0.236 0.191-0.419 0.532-0.549 1.024-0.171 0.639-0.256 1.714-0.256 3.226s0.076 2.551 0.229 3.116 0.347 0.941 0.579 1.13c0.233 0.188 0.5 0.28 0.801 0.28s0.568-0.095 0.805-0.285 0.418-0.532 0.549-1.024c0.17-0.633 0.256-1.705 0.256-3.217s-0.076-2.551-0.23-3.116c-0.153-0.565-0.345-0.943-0.578-1.134zM16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM18.858 20.983c-0.698 0.879-1.672 1.318-2.921 1.318-1.255 0-2.267-0.481-3.035-1.445s-1.152-2.682-1.152-5.154c0-2.426 0.422-4.172 1.267-5.238 0.698-0.879 1.672-1.318 2.921-1.318s2.226 0.445 2.93 1.336c0.838 1.055 1.258 2.803 1.258 5.247-0.001 2.437-0.424 4.189-1.268 5.254z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumber19SvgrepoCom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/number19-svgrepo-com.86254128.svg";
export { ForwardRef as ReactComponent };